module.exports = __webpack_public_path__ + "media/newstyle/images/book-de-de394fa8e6a9d86d8402038b896ff91b.png";